'use client';

import { useCallback, useState } from 'react';

interface UseSetStateResult<T> {
  items: Set<T>;
  add: (item: T) => void;
  remove: (item: T) => void;
  setItems: React.Dispatch<React.SetStateAction<Set<T>>>;
}

export function useSetState<T>(
  initialValue?: Set<T>,
): UseSetStateResult<T> {
  const [items, setItems] = useState<Set<T>>(initialValue ?? new Set<T>());

  const add = useCallback((item: T) => {
    setItems((prev) => {
      if (prev.has(item)) return prev;
      const next = new Set(prev);
      next.add(item);
      return next;
    });
  }, []);

  const remove = useCallback((item: T) => {
    setItems((prev) => {
      if (!prev.has(item)) return prev;
      const next = new Set(prev);
      next.delete(item);
      return next;
    });
  }, []);

  return { items, add, remove, setItems };
}
